// Libraries
import { action, computed, observable, runInAction } from "mobx";

// Core
import { FieldType, ViewModelBase, PostFormWithFile, ModelBase } from "@shoothill/core/";

import { AppUrls } from "AppUrls";

// Models
import { FileResponseDTO } from "Globals/Models/DTO/FileResponseDTO";
import { UserFile } from "Globals/Models/UserFile";

export class BasicModel extends ModelBase<BasicModel, BasicModel> {
    fromDto(model: BasicModel): void {
        throw new Error("Method not implemented.");
    }
    toDto(model: BasicModel): void {
        throw new Error("Method not implemented.");
    }
    @observable public documentTypeId: string = "";
}
export class FileUploaderViewModel extends ViewModelBase {
    @observable public filesToDisplay: UserFile[] = [];
    @observable public errorMessage: string = "";

    constructor(files: UserFile[]) {
        super(new BasicModel());
        this.filesToDisplay = files;
    }

    @action
    public upload = async (e: React.ChangeEvent<HTMLInputElement>, documentTypeId: string): Promise<UserFile | null> => {
        let files: FileList | null = e.target.files;
        if (files !== null && files !== undefined && files.length > 0) {
            if (files.length > 1) {
                throw new Error("Too many files!");
            }
            const file = files[0];
            try {
                const formData = new FormData();
                formData.append("formFile", file);
                formData.append("documentTypeId", documentTypeId);

                const apiResult = await this.Post<FileResponseDTO>(AppUrls.Server.File.UploadFile, formData);
                if (apiResult.wasSuccessful) {
                    let userFile: UserFile = {
                        id: apiResult.payload.id,
                        documentTypeId: apiResult.payload.documentTypeId,
                        fileName: file.name,
                        fileUrl: apiResult.payload.fileUrl,
                    };
                    runInAction(() => {
                        this.errorMessage = "";
                        this.filesToDisplay.push(userFile);
                    });
                    return userFile;
                } else {
                    files = null;
                    if (apiResult.wasSuccessful) {
                        runInAction(() => {
                            this.errorMessage = "Error uploading file please try again.";
                        });
                        this.setIsErrored(true);
                    }
                }
            } catch (exception) {
                console.error(exception);
                runInAction(() => {
                    this.errorMessage = "Error uploading file please try again.";
                });
                this.setIsErrored(true);
            }
        }
        return null;
    };
    @action
    public download = async (fileUrl: string, optionalFileName: string | undefined): Promise<void> => {
        let fileName = optionalFileName ? optionalFileName : fileUrl.substr(fileUrl.lastIndexOf("/") + 1);
        try {
            const apiResult = await this.Post<Blob>(AppUrls.Server.File.DownloadFile, fileUrl, undefined, { responseType: "blob" });
            const response = apiResult as any;
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
        } catch (exception) {
            console.error(exception);
            this.setIsErrored(true);
        }
    };
    @action
    public delete = async (userFile: UserFile): Promise<void> => {
        runInAction(() => {
            const index = this.filesToDisplay.indexOf(userFile);
            if (index > -1) {
                this.filesToDisplay.splice(index, 1);
            }
        });
    };

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public async isFieldValid(fieldName: keyof FieldType<FileUploaderViewModel>): Promise<boolean> {
        return true;
    }

    // #endregion Viewmodel Boilerplate
}
